module.exports = __webpack_public_path__ + "img/skills-mosaic-asn-3.b7f242a8.png";